export function triggerClientSideDownload({ content = '', contentType = '', fileName = '' }) {
  const blob = new Blob([content], { type: contentType });
  const link = document.createElement('a');

  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', fileName);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
